import { motion } from "framer-motion";
import { useContent } from "@/context/ContentContext";

const RINGS = [
  { r: 130, dur: "animate-spin-slow", nodes: ["AI", "Nightlife", "Culinary", "Fintech"] },
  { r: 210, dur: "animate-spin-slower", nodes: ["Virtual Worlds", "Creator", "Automation", "Social", "Hardware"] },
];

function ringNodes(nodes, radius) {
  return nodes.map((label, i) => {
    const angle = (i / nodes.length) * Math.PI * 2;
    return { label, x: Math.cos(angle) * radius, y: Math.sin(angle) * radius };
  });
}

export default function HeroOrbit() {
  const { content } = useContent();
  return (
    <div className="pointer-events-none relative flex h-full w-full items-center justify-center">
      <div className="radial-fade absolute inset-0" />

      {/* static concentric rings */}
      {RINGS.map((ring) => (
        <div
          key={ring.r}
          className="absolute rounded-full border border-white/[0.06]"
          style={{ width: ring.r * 2, height: ring.r * 2 }}
        />
      ))}

      {/* rotating node rings */}
      {RINGS.map((ring) => (
        <div key={`n-${ring.r}`} className={`absolute ${ring.dur}`} style={{ width: ring.r * 2, height: ring.r * 2 }}>
          {ringNodes(ring.nodes, ring.r).map((n) => (
            <div
              key={n.label}
              className="absolute flex items-center gap-1.5"
              style={{ left: `calc(50% + ${n.x}px)`, top: `calc(50% + ${n.y}px)`, transform: "translate(-50%,-50%)" }}
            >
              <span className="h-1.5 w-1.5 rounded-full bg-gold shadow-[0_0_10px_2px_rgba(212,175,55,0.6)]" />
              <span className="hidden whitespace-nowrap font-mono2 text-[9px] uppercase tracking-widest text-white/45 sm:inline">
                {n.label}
              </span>
            </div>
          ))}
        </div>
      ))}

      {/* center */}
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1, ease: [0.2, 0.8, 0.2, 1] }}
        className="relative z-10 flex flex-col items-center"
      >
        <div className="absolute h-40 w-40 rounded-full bg-gold/20 blur-3xl" />
        <img src={content.logo_url} alt="ImJove Tech" className="animate-floaty relative h-24 w-24 object-contain drop-shadow-[0_0_30px_rgba(212,175,55,0.4)]" />
      </motion.div>
    </div>
  );
}
